




















































































































































































































































































































































































































import Vue from 'vue'

const ASP_MAIL = 'ASP_MAIL';
const ET_MAIL = 'ET_MAIL';
const MSK_MAIL = 'MSK_MAIL';
const SPB_MAIL = 'SPB_MAIL';
const NN_MAIL = 'NN_MAIL';
const PERM_MAIL = 'PERM_MAIL';

export default Vue.extend({
  auth: false,
  middleware: [],
  name: "need-help",
  head: {
    title: 'Нужна помощь?'
  },
  data: () => ({
    //receiptFile: null,
    text: "",
    email: "",
    fullName: "",
    group: "",
    step: 'start',
    toMail: ET_MAIL,
    nonBachelorCampus: null,
    stepStory: [],
    campuses: [
      {
        'label': 'Москва',
        'mail': MSK_MAIL
      },
      {
        'label': 'Санкт-Петербург',
        'mail': SPB_MAIL
      },
      {
        'label': 'Нижний Новгород',
        'mail': NN_MAIL
      },
      {
        'label': 'Пермь',
        'mail': PERM_MAIL
      }
    ],
    isVisibleText: false,
    isAuth: false
  }),
  computed: {
    isValidEmail() {
      return this.email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    isValidCampus() {
      return !!this.toMail && this.campuses.map((e: {label: string, mail: string}) => e.mail).includes(this.toMail);
    }
  },
  methods: {
    setStart() {
      this.text = '';
      this.toMail = ASP_MAIL;
      this.changeStep('start');
    },
    onAfterGroupSubmit() {
      switch (this.group) {
        case "foreigner_bachelor":
          this.changeStep('foreigner_bachelor');
          break;
        case "bachelor":
          if (this.isAuth) {
            this.setIsET();
          } else {
            this.changeStep('auth');
          }
          break;
        case "foreigner_master":
          this.changeStep('foreigner_master');
          break;
      }
    },
    setIsET() {
      this.text = '';
      this.changeStep('et');
    },
    setET() {
      this.toMail = ET_MAIL;
      this.changeStep('text');
    },
    setMskMail() {
      this.toMail = MSK_MAIL
      this.changeStep('text');
    },
    toCampuses() {
      this.toMail = '';
      this.changeStep('campuses');
    },
    toFCampuses() {
      this.toMail = '';
      this.changeStep('f_campuses');
    },
    campusChange(value: string) {
      this.toMail = value;
    },
    campusSelected() {
      if (this.toMail === MSK_MAIL) {
        this.changeStep('mskSelect');
      } else {
        this.changeStep('text');
      }
    },
    send() {
      let data = {
        email: this.email,
        fullName: this.fullName,
        text: this.text,
        toMail: this.toMail,
      }
      this.$api("needHelpMessage", data, "POST")
        .then(() => {
          this.changeStep('finish');
        })
    },
    stepBack() {
      let currentStepIndex = this.stepStory.findLastIndex((s: string) => s === this.step);

      if (currentStepIndex >= 0) {
        // Если в истории есть текущий step:
        // получаем индекс перед текущим и ставим как текущий шаг
        this.step = this.stepStory[currentStepIndex - 1];
      } else {
        // Если в истории нет текущего step:
        // Ставим последний индекс из истории
        this.step = this.stepStory.at(-1);
      }
      this.isVisibleText = this.step === 'text'
    },
    changeStep(step: string) {
      console.log(this.stepStory.at(-1), step);
      if (this.stepStory.at(-1) !== this.step) {
        this.stepStory.push(this.step);
        this.stepStory = this.stepStory.slice(-10);
      }
      this.isVisibleText = step === 'text';
      this.step = step;
    }
  },
  mounted() {
    this.isAuth = this.$auth.loggedIn;
    //this.step = this.isAuth ? 'start' : 'auth';
  }
})
